module.exports = __webpack_public_path__ + "media/intro-landscape.ee96c97f.webm";